"use strict";
var __webpack_require__ = {};
(()=>{
    __webpack_require__.d = (exports1, definition)=>{
        for(var key in definition)if (__webpack_require__.o(definition, key) && !__webpack_require__.o(exports1, key)) Object.defineProperty(exports1, key, {
            enumerable: true,
            get: definition[key]
        });
    };
})();
(()=>{
    __webpack_require__.o = (obj, prop)=>Object.prototype.hasOwnProperty.call(obj, prop);
})();
(()=>{
    __webpack_require__.r = (exports1)=>{
        if ('undefined' != typeof Symbol && Symbol.toStringTag) Object.defineProperty(exports1, Symbol.toStringTag, {
            value: 'Module'
        });
        Object.defineProperty(exports1, '__esModule', {
            value: true
        });
    };
})();
var __webpack_exports__ = {};
__webpack_require__.r(__webpack_exports__);
__webpack_require__.d(__webpack_exports__, {
    default: ()=>svgs_ClearHistory
});
const jsx_runtime_namespaceObject = require("react/jsx-runtime");
require("react");
const ClearHistory = ({ size })=>/*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)("svg", {
        width: size,
        height: size,
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)("path", {
            d: "M11.1667 15.5L10 14.3333L11.75 12.5833L10 10.8333L11.1667 9.66667L12.9167 11.4167L14.6667 9.66667L15.8333 10.8333L14.1042 12.5833L15.8333 14.3333L14.6667 15.5L12.9167 13.7708L11.1667 15.5ZM7.5 15.5C5.58333 15.5 3.91319 14.8646 2.48958 13.5938C1.06597 12.3229 0.25 10.7361 0.0416667 8.83333H1.75C1.94444 10.2778 2.58681 11.4722 3.67708 12.4167C4.76736 13.3611 6.04167 13.8333 7.5 13.8333C7.65278 13.8333 7.79514 13.8299 7.92708 13.8229C8.05903 13.816 8.19444 13.7986 8.33333 13.7708V15.4583C8.19444 15.4722 8.05903 15.4826 7.92708 15.4896C7.79514 15.4965 7.65278 15.5 7.5 15.5ZM0 6.33333V1.33333H1.66667V3.29167C2.375 2.40278 3.23958 1.71528 4.26042 1.22917C5.28125 0.743056 6.36111 0.5 7.5 0.5C9.58333 0.5 11.3542 1.22917 12.8125 2.6875C14.2708 4.14583 15 5.91667 15 8H13.3333C13.3333 6.375 12.7674 4.99653 11.6354 3.86458C10.5035 2.73264 9.125 2.16667 7.5 2.16667C6.54167 2.16667 5.64583 2.38889 4.8125 2.83333C3.97917 3.27778 3.27778 3.88889 2.70833 4.66667H5V6.33333H0ZM8.625 10.2917L6.66667 8.33333V3.83333H8.33333V7.66667L9.5 8.83333L8.625 10.2917Z",
            fill: "#0068EF"
        })
    });
const svgs_ClearHistory = ClearHistory;
exports["default"] = __webpack_exports__["default"];
for(var __webpack_i__ in __webpack_exports__)if (-1 === [
    "default"
].indexOf(__webpack_i__)) exports[__webpack_i__] = __webpack_exports__[__webpack_i__];
Object.defineProperty(exports, '__esModule', {
    value: true
});
